import { formatDateTime } from "@/utils";
import ICON_CORNER from "@/assets/images/corner.svg";
// import MatchMinute from "./MatchMinute";


export default function MatchTime({
  homeCorner,
  awayCorner,
  homeScore,
  awayScore,
  swapScoreCorner = false,
  isLive,
  isFinished,
  isNotStarted,
  matchTime,
  liveScore,
  status,
  halfStartTime,
  className,
  textAlignment = "center",
}) {
  if (isFinished) {
    return (
      <div className="flex flex-col items-center gap-1 min-w-fit">
        <span className="text-sm whitespace-nowrap">Kết Thúc</span>
        {swapScoreCorner ? (
          <span className="text-sm font-semibold tabular-nums whitespace-nowrap">
            {homeScore}:{awayScore}
          </span>
        ) : (
          <div className="flex items-center gap-1 whitespace-nowrap">
            <img src={ICON_CORNER} alt="corner" width={8} height={8} />
            <span className="text-sm">{homeCorner}:{awayCorner}</span>
          </div>
        )}
      </div>
    );
  }

  if (isNotStarted && matchTime) {
    const { date, time } = formatDateTime(matchTime);
    return (
      <div className="flex flex-col gap-1 min-w-fit whitespace-nowrap">
        <span className="text-sm font-semibold">{time}</span>
        <span className="text-sm">{date}</span>
      </div>
    );
  }

  if (isLive && matchTime) {
    return (
      <div className={`flex flex-col gap-1 min-w-fit whitespace-nowrap ${className || ""}`}>
        {/* <MatchMinute
          liveScore={liveScore}
          status={status}
          matchTime={matchTime}
          halfStartTime={halfStartTime}
          className={`text-sm text-red leading-[1.2] text-red-600 text-${textAlignment}`}
        /> */}
        <div className="flex items-center gap-1 whitespace-nowrap">
          <img src={ICON_CORNER} alt="corner" width={8} height={8} />
          <span className="text-sm font-semibold text-surface-900">{homeCorner}:{awayCorner}</span>
        </div>
      </div>
    );
  }

  return null;
}